module.exports = "pegasus_template/assets/theme2/google-icon-1.png";